"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugPurchasesCancelPatchRequestToJSON = exports.ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSONTyped = exports.ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSON = exports.instanceOfApiStoresUrlSlugPurchasesCancelPatchRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ApiStoresUrlSlugPurchasesCancelPatchRequest interface.
 */
function instanceOfApiStoresUrlSlugPurchasesCancelPatchRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugPurchasesCancelPatchRequest = instanceOfApiStoresUrlSlugPurchasesCancelPatchRequest;
function ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSON(json) {
    return ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSON = ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSON;
function ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
    };
}
exports.ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSONTyped = ApiStoresUrlSlugPurchasesCancelPatchRequestFromJSONTyped;
function ApiStoresUrlSlugPurchasesCancelPatchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reference_id': value.referenceId,
    };
}
exports.ApiStoresUrlSlugPurchasesCancelPatchRequestToJSON = ApiStoresUrlSlugPurchasesCancelPatchRequestToJSON;
